import axios from 'axios';
import router from '@/plugins/routes';
import { uuid } from 'vue-uuid';

export const state = {
  title: 'My state title',
  forms: [],
  folders: [],
  favorites: {
    elements: [],
  },
  fieldValues: {},
  pwaInstallPromptLastShown: 0,
};

export const getters = {
  getFormByID: (state) => (form_name) => {
    return state.forms.find(({ form_id }) => form_id === form_name);
  },
  getFormByGuestID: (state) => (guest_id) => {
    return state.forms.find(({ form_guest_id }) => form_guest_id === guest_id);
  },
  getFolderByID: (state) => (folder) => {
    return state.folders.find(({ folder_id}) => folder_id === folder);
  },
  getFieldValue: (state) => (field_uuid) => {
    if (state.fieldValues[field_uuid]) {
      return state.fieldValues[field_uuid].value;
    }
    else {
      return undefined;
    }
    // return state.fieldValues.find(({ uuid }) => uuid === field_uuid);
  },

};

export const actions = {
  async createForm ( { commit, state }, {form_name, folder_id, form_type, schema} ) {
    let client_id = state.auth.currentClient;
    const form = {
      form_id: uuid.v4(),
      form_name: form_name,
      form_type: form_type,
      folder_id: folder_id,
      client_id: client_id,
      schema: schema,
      rules: [],
      values: {},
      email_settings: [],
    };
    if (form_type === 'workflow') {
      // Set default registration phase
      form.registration_phase = "1";
    }

    let response = await axios.post('api/form', form);

    await commit('createForm', {form: response.data});

    router.push({ name: 'form_edit', params: {form_id: response.data.form_id} })

  },
  async createDuplicateFromForm ( { commit }, {form_id, new_client_id, new_folder_id, new_form_name, published}) {

    // Set default values
    if (typeof published === 'undefined') {
      published = false;
    }

    let response = await axios.post('api/form/'+form_id+'/duplicate', {
      new_client_id: new_client_id,
      new_folder_id: new_folder_id,
      new_form_name: new_form_name,
      published: published,
    });

    await commit('createForm', {form: response.data});

    return response.data.form_id;
  },
  async registrationCompleted({commit}, {registration}) {
    commit('clearOldFieldValues');
    commit('storeInputValues', {form: registration});
  },
  async getFolders({commit, state}) {
    let client_id = state.auth.currentClient;
    let response = await axios.get('/api/client/'+client_id+'/folder');
    commit('setFolders', {folders: response.data});
  },
  async createFolder ( { commit, state }, {folder_name, hidden, form_folder}) {
    let client_id = state.auth.currentClient;
    const folder = {
      folder_name: folder_name,
      form_folder: form_folder,
      hidden: hidden,
    };

    let response = await axios.post('api/client/'+client_id+'/folder', folder);

    if (!response.data) {
      throw new Error(response.toString());
    }

    await commit('createFolder', {folder: response.data});

    return response.data;
  },
  async addFavoriteElement({commit, dispatch}, {newFavorite}) {
    delete newFavorite.name;
    newFavorite.uuid = uuid.v4();

    // let response = await axios.post('api/favorite/elements', newFavorite);
    await commit('addFavoriteElement', {favorite: newFavorite});

    return dispatch('getFavoriteElements');
  },
  async removeFavoriteElement({commit}, {favoriteElementId}) {
    // let response = await axios.post('api/favorite/elements', newFavorite);
    await commit('removeFavoriteElement', {favoriteElementId: favoriteElementId});
  },
  async getFavoriteElements({state}) {
    return state.favorites.elements;
  },
};

export const mutations = {
  createForm(state, {form}) {
    state.forms.push(form);
  },
  updateForm(state, {form}) {
    let index = state.forms.findIndex(e=> e.form_id === form.form_id);
    state.forms[index] = form;
  },
  setFolders(state, {folders}) {
    state.folders = folders;
  },
  createFolder(state, {folder}) {
    state.folders.push(folder);
  },
  storeInputValues(state, {form}) {
    for (let i = 0; i < form.schema.length; i++) {
      if (form.schema[i].rememberInput) {
        let uuid = form.schema[i].uuid;
        let fieldName = form.schema[i].name;

        if (form.values[fieldName]) {
          console.log('Storing field value for field ' + fieldName + '. Value: ' + form.values[fieldName]);
          state.fieldValues[uuid] = {
            value: form.values[fieldName],
            timestamp: new Date(),
          }
        }
        else {
          console.log('Deleting field value for field ' + fieldName + '.');
          delete state.fieldValues[uuid];
        }
      }
    }
  },
  clearOldFieldValues(state) {
    // If it's not set or not an object we'll ignore it, no fieldValues set.
    if (!state.fieldValues || typeof state.fieldValues !== 'object') {
      return;
    }

    // Deletes field values older than 6 months.
    var oldDate = new Date();
    oldDate.setMonth(oldDate.getMonth() - 6);

    // Clears field values older than 6 months from the store
    for (const [fieldId, value] of Object.entries(state.fieldValues)) {
      // Get date 6 months prior
      if (!('timestamp' in value) || value.timestamp < oldDate) {
        // Is older or has no timestamp: EXTERMINATE!
        delete state.fieldValues[fieldId];
      }
    }
  },
  pwaInstallPromptIsShown(state) {
    let timestamp = Math.floor(Date.now() / 1000)
    state.pwaInstallPromptLastShown = timestamp
  },
  addFavoriteElement(state, {favorite}) {
    if (state.favorites.elements && Array.isArray(state.favorites.elements)) {
      state.favorites.elements.push(favorite);
    }
    else {
      state.favorites.elements = [favorite];
    }
  },
  removeFavoriteElement(state, {favoriteElementId}) {
    let favElementIndex = state.favorites.elements.findIndex(({ uuid }) => uuid === favoriteElementId);
    state.favorites.elements.splice(favElementIndex, 1);
  },
  setFavoriteElements(state, {favorites}) {
    state.favorites.elements = favorites;
  }
};
